import React, { useState, useEffect } from "react";
import { listUrl } from "../Data";

import { ImageCustom } from "../Image/index";

import {
  PolicySustainabilitysection,
  PolicySustainabilityBox,
  PolicySustainabilityTitle,
  PolicySustainabilityCard,
  PolicySustainabilityDescription,
  PolicySustainabilitySubTitle,
  PolicySustainabilityWrapper,
  PolicySustainabilityLink,
} from "./style";

const PolicySustainabilityComponent = () => {
  const [mobile, setMobile] = useState(false);

  const isMobile = () => {
    const { innerWidth } = window;

    setMobile(innerWidth <= 768);
  };

  useEffect(() => {
    isMobile();
  }, []);

  return (
    <PolicySustainabilitysection id="Politica-de-Sustentabilidade">
      <ImageCustom
        src={
          mobile
            ? listUrl.policeSustainability.bannerMobile
            : listUrl.policeSustainability.bannerDesk
        }
        alt=""
      />
      <PolicySustainabilityBox>
        <PolicySustainabilityWrapper>
          <PolicySustainabilityTitle>Política de </PolicySustainabilityTitle>
          <PolicySustainabilitySubTitle>
            Sustentabilidade
          </PolicySustainabilitySubTitle>
          <PolicySustainabilityCard>
            <PolicySustainabilityDescription>
              Em 2021, implementamos nossa Política de Sustentabilidade que
              consolida nossa estratégia de desenvolvimento sustentável dos
              negócios e demais atividades, adotando boas práticas de gestão
              ambiental, social e de governança em nossa cadeia de valor.
            </PolicySustainabilityDescription>
            <PolicySustainabilityDescription>
              As diretrizes da Política de Sustentabilidade da Arezzo&Co
              estabelecem compromissos e metas para nossa atuação, focadas na
              redução de impactos negativos, na promoção de impactos positivos e
              na geração de valor para nossos públicos de interesse.
            </PolicySustainabilityDescription>
            <PolicySustainabilityDescription>
              O documento está alinhado aos nossos princípios de atuação ética,
              transparente e sustentável, para a condução das operações em
              conformidade com aspectos socioambientais, normas, regulamentos e
              legislação vigentes aplicáveis aos negócios, além de firmar nosso
              compromisso em comunicar, de forma transparente, nosso desempenho
              em relação aos temas abordados.
            </PolicySustainabilityDescription>
            <PolicySustainabilityDescription>
              Para saber mais, acesse na íntegra nossa{" "}
              <PolicySustainabilityLink
                href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Política de sustentabilidade.pdf"
                target="_blank"
              >
                Política de Sustentabilidade Arezzo&Co.
              </PolicySustainabilityLink>
            </PolicySustainabilityDescription>
          </PolicySustainabilityCard>
        </PolicySustainabilityWrapper>
      </PolicySustainabilityBox>
    </PolicySustainabilitysection>
  );
};

export default PolicySustainabilityComponent;
